import { MOCK_FLIGHT_TRACKER_COPY } from '@dynamic-components/flight-tracker/flight-tracker.copy.mock';
import { FlightTrackerCopy } from '@dynamic-components/flight-tracker/types/flight-tracker-copy.type';
import { FlightTrackerFlight } from '@dynamic-components/flight-tracker/types/flight-tracker-result.type';
import { BookerResponse, MOCK_BOOKER_RESPONSE } from '@shared/booker';
import { CountryWithAirports } from '@store/origins/types';
import { startOfToday } from 'date-fns';

import { FlightTrackerHttpErrorResponse } from '../flight-tracker.type';

export interface FlightTrackerSearchComponentState {
  originAirports: CountryWithAirports[];
  destinationAirports: CountryWithAirports[];
  flightTrackerResponse: FlightTrackerCopy;
  bookerResponse: BookerResponse;
  today: Date;
  selectedTabId: FlightTrackerTabId;
  submitting: boolean;
  flightResults: {
    departureDate: string;
    connectingFlightResults: FlightTrackerFlight[];
    directFlightResults: FlightTrackerFlight[];
    error?: FlightTrackerHttpErrorResponse;
  };
}

export const flightTrackerSearchComponentInitialState: FlightTrackerSearchComponentState =
  {
    originAirports: [],
    destinationAirports: [],
    flightTrackerResponse: MOCK_FLIGHT_TRACKER_COPY,
    bookerResponse: MOCK_BOOKER_RESPONSE,
    today: startOfToday(),
    selectedTabId: undefined,
    submitting: false,
    flightResults: undefined,
  };

export enum FlightTrackerTabId {
  byRoute = 'by-route',
  byFlight = 'by-flight',
}

export interface FlightTrackerSearchComponentViewModel
  extends FlightTrackerSearchComponentState {
  flightTrackerTabs: { title: string; id: string }[];
  dateOptions: DateOption[];
}

export interface DateOption {
  id: string;
  name: string;
  value: string;
}
